import {handleValidationChange} from '../CommonValidation';

export const validateAddSO= (data, items, setIsError) => {
    var isValid = true;

   
    if(data.supplier_id === "") {
        handleValidationChange("supplier_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("supplier_id", false, setIsError);
        isValid = true;
    }

    if(data.branch_id === "" || data.branch_id === undefined || data.branch_id === null) {
        handleValidationChange("branch_id", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
        isValid = true;
    }

    if(data.supplies_expense_date === "" || data.supplies_expense_date === undefined || data.supplies_expense_date === "Invalid Date") {
        handleValidationChange("supplies_expense_date", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("supplies_expense_date", false, setIsError);
        isValid = true;
    }

    if(data.delivery_date === "" || data.delivery_date === undefined || data.purchase_date === "Invalid Date") {
        handleValidationChange("delivery_date", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("delivery_date", false, setIsError);
        isValid = true;
    }

    if(data.requisitioner === "" || data.requisitioner === undefined) {
        handleValidationChange("requisitioner", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("requisitioner", false, setIsError);
        isValid = true;
    }

    if(data.type === "" || data.type === undefined) {
        handleValidationChange("type", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("type", false, setIsError);
        isValid = true;
    }

    if(data.delivery_address === "" || data.delivery_address === undefined) {
        handleValidationChange("delivery_address", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("delivery_address", false, setIsError);
        isValid = true;
    }

    if(items.length < 1) {
        handleValidationChange("itemList", true, setIsError);
        isValid = false;
    } else {
        handleValidationChange("itemList", false, setIsError);
        isValid = true;
    }

    return isValid
  
}


export const validateSuppliesExpenseItems = (items) => {
    const errors = {};
    // const finalItems = []
    items.map((item, itemIndex) => {
      if (item.name === '' || item.name === undefined || item.name === null) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          name: 'Item is required',
        };
      }

      if (!(item.qty.toString())|| (parseInt(item.qty) <= 0)) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          qty: 'Qty is required and should be greater than 0',
        };
      }

      if (!(item.unit.toString())||item.unit==='') {
        errors[itemIndex] = {
          ...errors[itemIndex],
          unit: 'Unit is required',
        };
      }

      if (!item.price || (parseInt(item.price) <= 0)) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          price: 'Price is required and should be greater than 0',
        };
      }
    });
    return errors;
}